import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { authService } from "../services/apiService";

export const useAuthController = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login, logout, user, isAuthenticated } = useAuthStore();

  const handleLogin = async (credentials) => {
    setError("");
    setLoading(true);
    try {
      const payload = {
        email: (credentials.email || "").trim().toLowerCase(),
        password: credentials.password || "",
      };

      const response = await authService.login(payload);

      if (!response?.success || !response?.data) {
        throw new Error(response?.msg || "Login failed");
      }

      const userData = response.data.user || response.data;
      const token = response.data.token;
      const permissions = response.data.permissions || [];

      if (!userData || !token) {
        throw new Error("Invalid response: missing user or token");
      }

      login(userData, token, permissions);
      navigate("/dashboard");
      return { success: true };
    } catch (err) {
      const message =
        err.response?.data?.msg ||
        err.response?.data?.message ||
        err.message ||
        "Login failed. Please check your credentials and try again.";
      setError(message);
      return { success: false, error: message };
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    logout();
    navigate("/login");
  };

  return {
    loading,
    error,
    user,
    isAuthenticated,
    handleLogin,
    handleLogout,
    clearError: () => setError(""),
  };
};
